import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const Loader = ({
  pageTitle,
  pageText,
  onRetry,
}: {
  pageTitle: string;
  pageText?: string;
  onRetry?: () => void;
}) => {
  const [show, setShow] = useState(true);
  // Phase 0: normal spinner
  // Phase 1 (8 s): "Dit duurt langer dan verwacht..."
  // Phase 2 (20 s): "Verbinding mislukt" + retry button
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 8000);
    const t2 = setTimeout(() => setPhase(2), 20000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  const handleClose = () => setShow(false);

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  const subtitle =
    phase === 2
      ? "Kan geen verbinding maken met de server."
      : phase === 1
      ? "Dit duurt langer dan verwacht..."
      : pageText;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        closeButton={false}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="d-flex align-items-center flex-column">
          <Modal.Title>
            {phase === 2 ? "Verbinding mislukt" : pageTitle}
          </Modal.Title>
          {subtitle && (
            <p className="mb-0 mt-1 text-muted" style={{ fontSize: "0.875rem" }}>
              {subtitle}
            </p>
          )}
        </div>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center flex-column align-items-center gap-3">
        {phase < 2 ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <Button variant="primary" onClick={handleRetry}>
            Opnieuw proberen
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Loader;
